export let Spec = /*#__PURE__*/function (Spec) {
  Spec["ProGallery"] = "specs.siteSearch.ProGallery";
  Spec["UseWarmupData"] = "specs.siteSearch.UseWarmupData";
  Spec["SkipNavigationStep"] = "specs.siteSearch.SkipNavigationStep";
  Spec["ChangeSelectedTabInEditorOnEdit"] = "specs.siteSearch.ChangeSelectedTabInEditorOnEdit";
  Spec["CSSPerBreakpointIndications"] = "specs.siteSearch.CSSPerBreakpointIndications";
  Spec["NewSearchOnClassicEditor"] = "specs.siteSearch.NewSearchOnClassicEditor";
  return Spec;
}({});
//# sourceMappingURL=specs.js.map